import { RouteObject } from "react-router-dom";

const DesignSystemRoute: RouteObject = {
    path: "design-system/:section?",
    async lazy() {
        const { DesignSystemPage } = await import("@/pages/tools/design-system");
        return { Component: DesignSystemPage };
    }
};
export default DesignSystemRoute;
